module.exports = __webpack_public_path__ + "img/2.16e4d9cd.png";